import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["for"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("y-input-wrapper", null, [
    _createElementVNode("label", {
      slot: "label",
      for: $setup.randomId
    }, _toDisplayString($props.label), 9 /* TEXT, PROPS */, _hoisted_1),
    _createVNode($setup["TimeFieldRoot"], {
      locale: "nl",
      id: $setup.randomId,
      "model-value": $setup.convertDateToTimeValue($props.modelValue),
      required: "",
      class: "time__field order-form__input-text",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = (val) => {
        const now = new Date();

        if (val) {
          now.setHours(val.hour);
          now.setMinutes(val.minute);
        }

        _ctx.$emit('update:modelValue', now)

      })
    }, {
      default: _withCtx(({ segments }) => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segments, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.part
          }, [
            (item.part === 'literal')
              ? (_openBlock(), _createBlock($setup["TimeFieldInput"], {
                  key: 0,
                  part: item.part,
                  class: "time__field__input time__field__input--literal"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.value), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["part"]))
              : (_openBlock(), _createBlock($setup["TimeFieldInput"], {
                  key: 1,
                  part: item.part,
                  class: "time__field__input time__field__input--value"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.value), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["part"]))
          ], 64 /* STABLE_FRAGMENT */))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["id", "model-value"])
  ]))
}